module.exports = __webpack_public_path__ + "img/WhatIsPII.95da5b0e.jpg";